import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const zingerPairs = [
  "Stop working harder. Start training smaller.",
  "Lectures talk. Microskills measure.",
  "Skip the 40-hour course. Master the 4 minutes that matter."
];

export default function ZingerBanner() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIndex((prev) => (prev + 1) % zingerPairs.length);
    }, 7500); // Hold each zinger for 7.5 seconds

    return () => clearTimeout(timer);
  }, [index]);

  return (
    <div className="text-center py-12 px-4 sm:px-8 md:px-16">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.6 }}
          className="text-2xl md:text-3xl font-semibold text-black"
        >
          {zingerPairs[index]}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
